<template>
  <main class="home">
    <div class="container px-3 pt-5">
      <img
        src="/img/error_image.png"
        alt="error image"
        class="mx-auto d-block mt-5"
      />
      <div class="row justify-content-center">
        <div class="col mt-3 mb-5 mx-5">
          <h2 class="text-center">{{ t("SHARED.PAGE_NOT_FOUND") }}</h2>
          <p class="text-center mx-auto mt-3">
            {{ t("SHARED.PAGE_NOT_FOUND_DESCRIPTION") }}
          </p>
        </div>
      </div>
      <button
        class="mx-auto position-fixed start-0 end-0"
        v-if="showActionBtn"
        @click="btnClick"
      >
        {{ btnText }}
      </button>
    </div>
  </main>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";

const { t } = useI18n();

const showActionBtn = ref<boolean>(false);
const btnText = ref<string>("");

const route = useRoute();

onMounted(() => {
  // Check if the path is actually an external URL
  if (route.path.startsWith("/http")) {
    // Remove the leading slash
    window.location.href = route.path.substring(1);
    return;
  }

  switch (true) {
    case route.path.includes("creditline"):
      btnText.value = t("SHARED.GOHOME");
      showActionBtn.value = true;
      break;
    case route.path.includes("core-app-onboarding"):
      btnText.value = t("SHARED.GOHOME");
      showActionBtn.value = true;
      break;
    default:
      break;
  }
});

const btnClick = () => {
  if (window?.Android !== undefined) {
    window?.Android?.dismissWebView();
    return;
  }

  history.back();
};
</script>

<style lang="scss" scoped>
h2 {
  color: black;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}

p {
  width: 206px;
  color: #8b8b8b;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}

button {
  border-radius: 5px;
  border: none;
  background: #007c3b;
  color: white;
  font-size: 16px;
  min-height: 48px;
  font-family: Inter, serif;
  font-weight: 600;
  bottom: 5%;
  word-wrap: break-word;
  width: 90%;
}
</style>
